const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://78wd09khll.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://87w4murqa4.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.datainsights.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.datainsights.forwoodsafety.com',
    WEBSOCKET: 'wss://dnjv875rxk.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
